import { Reminder, ReminderBasedOn, TranslateFunction } from '@griply/types';

import { formatDurationLabel } from '../format-duration-label';
import { formatTimeOfDay } from '../format-time-of-day';
import { findReminderPreset } from './get-reminder-options';

// Null when no label can be derived, so the caller can format its own fallback.
export const getReminderLabel = (
  reminder: Reminder,
  t: TranslateFunction,
): string | null => {
  const preset = findReminderPreset(reminder);
  if (preset) {
    return t(preset.labelKey);
  }

  if (reminder.basedOn === ReminderBasedOn.DayStart) {
    const time = formatTimeOfDay(reminder.offset);
    if (time) {
      return t('reminders.on-day-at', { time });
    }
  }

  if (reminder.basedOn === ReminderBasedOn.Start) {
    const duration = formatDurationLabel(-reminder.offset);
    if (duration) {
      return t('reminders.offset-before', { duration });
    }
  }

  return null;
};
